<template>
    <div itemscope itemtype="http://schema.org/Thing">
        <social-media-meta :object='object'></social-media-meta>

        <div class='row'>
            <div class='col-md-2 hidden-print'></div>
            <div class='col-md-10'>
                <h1 :itemprop="meta(object._index, 'title')">{{object.searchable.title[0]}}</h1>
            </div>
        </div>

        <!-- Related -->
        <div class='row' v-if='hasNonAssociationRelations(object.relation_count)'>
            <div class='col-md-2 hidden-print'></div>
            <div class='col-md-3'><strong>Related</strong></div>
            <div class='col-md-7'>
                <related :object='object'></related>
            </div>
        </div>
        <div v-else class='row'>
            <div class='col-md-2 hidden-print'></div>
            <div class='col-md-7'>
                No records are tied to this Association.
            </div>
        </div>
    </div>
</template>

<script>
    var moment = require('moment')
    import manageProperties from './../../mixins/manageProperties.js'
    import manageRelations from './../../mixins/manageRelations.js'
    import manageMetatags from './../../mixins/manageMetatags.js'
    import SocialMediaMetaVue from './parts/socialMediaMeta.vue'
    import RelatedVue from './parts/related.vue'
    import NoncustomVue from './parts/noncustom.vue'

    export default {
        mixins: [manageProperties, manageRelations, manageMetatags],
        props: ['object'],
        components: {
            'noncustom-prop': NoncustomVue,
            'related': RelatedVue,
            'social-media-meta': SocialMediaMetaVue
        },
        data: function () {
            return {
                ignored: [
                    'custom_related',
                    'custom_record_updated'
                ],
            }
        }
    }
</script>
